import { render, staticRenderFns } from "./GoogleSummaryChart.vue?vue&type=template&id=513cdba5&scoped=true&"
import script from "./GoogleSummaryChart.vue?vue&type=script&lang=js&"
export * from "./GoogleSummaryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513cdba5",
  null
  
)

export default component.exports